<template>
    <div v-if="students.length" class="card mb-3">
        <div class="card-header">
            <router-link
                :to="{ name: 'my_students' }"
            >
                <h6 class="card-subtitle">
                    <font-awesome-icon icon="child" class="mr-2" />
                    My Students
                </h6>
            </router-link>
            <span class="text-muted">Select student to view information and to make changes.</span>
        </div>
        <div class="card-body card-scroll text-center">
            <router-link
                v-for="(student, idx) in students"
                v-bind:key="idx"
                class="btn btn-primary col-sm-2 m-2"
                :to="{ name: 'parent_view_student', params: { id: student.id }}"
            >
                <i v-if="student.has_account" class="fas fa-address-card"></i>
                {{ student.first_name }}
            </router-link>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
    computed: mapState(["students"])
}
</script>